import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=042b87cd&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=042b87cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b87cd",
  null
  
)

export default component.exports